
import type { Filter } from '@empathyco/x-types'
import type { PropType } from 'vue'
import { HierarchicalFilter } from '@empathyco/x-components/facets'
import { defineComponent } from 'vue'

import { UiRadio } from '../../keen-ui'

export default defineComponent({
  name: 'XFilter',
  components: {
    HierarchicalFilter,
    UiRadio,
  },
  props: {
    filter: {
      type: Object as PropType<Filter>,
      required: true,
    },
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-x-filter',
    }
  },
})
